import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import Modal from "@amzn/aws-marketing-identity-kit-common-components-modal";
import { useIsMobile } from "@amzn/rigel-hooks/useBreakpoint";
import "@amzn/aws-marketing-identity-kit-common-components-modal/dist/styles/styles.min.css";
import { AWSM_VALID_SESSION_COOKIE_NAME, InteractableElements, } from "../constants";
import { useLocalizedString } from "@amzn/aws-marketing-identity-kit-localizations";
import { getCookie } from "../util";
import { SignInType } from "@amzn/aws-marketing-identity-kit-essentials";
const FederateLoginModal = ({ theme, labels, handleOnElementClick, login, profile, getEncodedUrl, container, useContainer, }) => {
    const [open, setOpen] = useState(false);
    const { t } = useLocalizedString();
    const isDark = theme === "dark";
    const isMobile = useIsMobile();
    const prefix = "federateLoginModalShown_";
    const validSessionCookie = getCookie(AWSM_VALID_SESSION_COOKIE_NAME);
    const key = validSessionCookie ? `${prefix}${validSessionCookie}` : undefined;
    useEffect(() => {
        const keysToRemove = [];
        for (let i = 0; i < localStorage.length; i++) {
            const k = localStorage.key(i);
            if (k && k.startsWith(prefix) && k !== key) {
                keysToRemove.push(k);
            }
        }
        keysToRemove.forEach((k) => localStorage.removeItem(k));
    }, [key]);
    const NAV_IDS = {
        DESKTOP: "global-nav-desktop",
        MOBILE: "global-nav-mobile",
    };
    const AMAZON_EMAIL_DOMAIN = "@amazon";
    const BUILDER_ID_TOKEN_TYPE = "BuilderId";
    const isInCorrectNavContext = (navElement) => {
        if (!navElement || isMobile === null)
            return false;
        const isDesktopNav = navElement.id === NAV_IDS.DESKTOP;
        const isMobileNav = navElement.id === NAV_IDS.MOBILE;
        if (!isDesktopNav && !isMobileNav)
            return false;
        return isMobile ? isMobileNav : isDesktopNav;
    };
    const shouldShowModalForProfile = () => {
        return Boolean(profile?.email?.includes(AMAZON_EMAIL_DOMAIN) &&
            profile?.tokenProvider?.type === BUILDER_ID_TOKEN_TYPE);
    };
    const isModalNotShownBefore = () => {
        return Boolean(key && !localStorage.getItem(key));
    };
    useEffect(() => {
        if (!container)
            return;
        const navParent = container.closest("nav");
        if (isInCorrectNavContext(navParent) &&
            shouldShowModalForProfile() &&
            isModalNotShownBefore() &&
            !document.querySelector(`[data-testid="navatarFederateModelContent"]`)) {
            setOpen(true);
        }
    }, [key, profile?.email, profile?.tokenProvider?.type, isMobile]);
    const closeFederateLoginModal = () => {
        setOpen(false);
        if (key) {
            localStorage.setItem(key, "true");
        }
    };
    return (_jsx(Modal, { isOpen: open, onClose: closeFederateLoginModal, container: useContainer ? container : undefined, children: _jsxs("div", { "data-component": "idk-navatar", "data-testid": "navatarFederateModelContent", children: [_jsx("h2", { className: "text-2xl font-bold mb-4", children: labels?.federateLoginModalTitle ||
                        t("Navatar.federateLoginModalTitle") }), _jsx("p", { className: "text-normal", children: labels?.federateLoginModalFirstDescription ||
                        t("Navatar.federateLoginModalFirstDescription") }), _jsx("br", {}), _jsx("p", { className: "text-normal", children: labels?.federateLoginModalSecondDescription ||
                        t("Navatar.federateLoginModalSecondDescription") }), _jsxs("div", { className: "flex gap-2 mt-8 w-full", children: [_jsx("button", { onClick: closeFederateLoginModal, className: `w-[50%] h-11 border-2 rounded-full transition-shadow duration-300 
            whitespace-nowrap truncate
            ${isDark
                                ? "border-white text-white"
                                : "border-colorBaseGray850 text-colorBaseGray850"}
            hover:shadow-glow
            active:shadow-glow-active
            focus:outline-none focus:ring-2 focus:ring-blue-500`, "data-testid": "navatarFederateModelSecondaryButton", children: _jsx("span", { className: "text-sm", children: labels?.federateLoginModalSecondaryButton ||
                                    t("Navatar.federateLoginModalSecondaryButton") }) }), _jsx("button", { onClick: () => {
                                handleOnElementClick(InteractableElements.LOG_IN);
                                if (login) {
                                    login(getEncodedUrl(), SignInType.Federate);
                                }
                                setOpen(false);
                            }, className: `w-[50%] h-11 border-2 rounded-full flex items-center justify-center 
            transition-shadow duration-300 
            whitespace-nowrap
            ${isDark
                                ? "border-white bg-white text-colorBaseGray850"
                                : "border-colorBaseGray850 bg-colorBaseGray850 text-white"}
            hover:shadow-glow
            active:shadow-glow-active
            focus:outline-none focus:ring-2 focus:ring-blue-500`, "data-testid": "navatarFederateModelPrimaryButton", children: _jsx("span", { className: "text-sm", children: labels?.federateLoginModalPrimaryButton ||
                                    t("Navatar.federateLoginModalPrimaryButton") }) })] })] }) }));
};
export default FederateLoginModal;
//# sourceMappingURL=FederateLoginModal.js.map